import { render, staticRenderFns } from "./newlaunchBanner.vue?vue&type=template&id=7789caf2&scoped=true&"
import script from "./newlaunchBanner.vue?vue&type=script&lang=js&"
export * from "./newlaunchBanner.vue?vue&type=script&lang=js&"
import style0 from "./newlaunchBanner.vue?vue&type=style&index=0&id=7789caf2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7789caf2",
  null
  
)

export default component.exports